import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface UserPhone {
  id: number
  contact: boolean
  number: string
  type: SystemCode
}

export function UserPhoneFromJSON(json: any): UserPhone {
  return {
    id: json.id,
    contact: exists(json, 'contact') ? json.contact : false,
    number: exists(json, 'number') ? json.number : '',
    type: exists(json, 'type')
      ? SystemCodeFromJSON(json.type)
      : defaultSystemCode()
  }
}

export function UserPhoneToJSON(value: UserPhone): any {
  return {
    id: value.id,
    contact: value.contact,
    number: value.number,
    type: value.type.code
  }
}
